import React from "react";
import topNailBanner from "./../../../../../Images/Blog/Top_10_Nail_Art/Banner.png";

const TopNailArtsImg = () => {
  return (
    <div className="blogImg-content">
      <img src={topNailBanner} alt="top Nail Banner" loading="lazy" />
    </div>
  );
};

export default TopNailArtsImg;
